var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { css } from '@emotion/css';
import { observer } from 'mobx-react-lite';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useUploadManager } from '../../UploadManagerProvider';
import { DrawerListSpinner } from '../Drawer/DrawerListSpinner';
const style = css `
    margin-bottom: -32px;
    margin-right: -12px;
    overflow-y: scroll;
    &::-webkit-scrollbar {
        width: 5px;
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 20px;
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
    }
    height: 100%;
`;
/**
 * Infinitely scrolling list
 */
export const InfiniteScrollContainer = observer((props) => {
    const { children, loadingSpinnerElement = _jsx(DrawerListSpinner, {}), infiniteScrollId } = props;
    const { fetchingStatus, canFetchMore, fetchMore, visibleAssets } = useUploadManager();
    const infiniteScrollContainerRef = useRef(null);
    useEffect(() => {
        var _a, _b;
        if (infiniteScrollContainerRef === null || infiniteScrollContainerRef === void 0 ? void 0 : infiniteScrollContainerRef.current) {
            const hasVerticalScrollbar = ((_a = infiniteScrollContainerRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight) > ((_b = infiniteScrollContainerRef.current) === null || _b === void 0 ? void 0 : _b.clientHeight);
            if (!hasVerticalScrollbar && canFetchMore && fetchMore && fetchingStatus === 'ready') {
                fetchMore();
            }
        }
    }, [canFetchMore, fetchMore, fetchingStatus, infiniteScrollContainerRef]);
    return (_jsx("div", Object.assign({ ref: infiniteScrollContainerRef, className: style, id: infiniteScrollId }, { children: _jsx(InfiniteScroll, Object.assign({ dataLength: visibleAssets.length, next: () => __awaiter(void 0, void 0, void 0, function* () {
                if (fetchingStatus === 'ready' && canFetchMore && fetchMore) {
                    fetchMore();
                }
            }), hasMore: canFetchMore || false, loader: loadingSpinnerElement, scrollableTarget: infiniteScrollId, style: { overflow: 'visible' } }, { children: children })) })));
});
//# sourceMappingURL=InfiniteScrollContainer.js.map